import { ApiUrls } from '../../../../../api/api/apiUrls';
import { useGetCachedPaginatedData } from '../../../../../api/cachedDataHooks';
import { TaskDto } from '../../../../api';

/**
 * Custom hook to fetch tasks data for the current user.
 * @returns tasks array.
 */
export function useTasksData() {
    const { data: tasksData } = useGetCachedPaginatedData<TaskDto>({
        url: ApiUrls.userApi.getTasks(),
        queryKey: 'TASKS',
    });

    const tasks = Array.isArray(tasksData) ? tasksData : [];

    return { tasks };
}
